module.exports = __webpack_public_path__ + "img/IMG_9923.07cb601c.jpg";